import request from '@/utils/request'

/**
 * 按收费员统计收费汇总
 * @param {Object} params - { communityIds, startDate, endDate, page, row, feeTypeCd }
 * @returns {Promise}
 */
export function queryCashierFeeSummary(params) {
  return request({
    url: '/reportFeeMonthStatistics.queryCashierFeeSummary',
    method: 'post',
    data: params
  })
}

/**
 * 收费员收费汇总导出
 * @param {Object} params - { pagePath, communityId, startDate, endDate, feeTypeCd }
 * @returns {Promise}
 */
export function exportCashierFeeSummary(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
